import Spinner from "@/components/Spinner";
import AsyncButton from "@/components/AsyncButton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ContractorPanelVisitsHeader } from "@/modules/contractor-panel/visits/components/ContractorPanelVisitsHeader";
import { useTranslation } from "react-i18next";
import { useContractorPanelPlannedHours } from "../hooks/useContractorPanelPlannedHours";

export const ContractorPanelPlannedHoursDirectory = () => {
  const { t } = useTranslation();
  const {
    acceptedPlannedHours,
    isBusy,
    isSubmitting,
    shouldShowPlannedHoursButton,
    shouldShowNoChangesMessage,
    showHours,
  } = useContractorPanelPlannedHours();

  return (
    <div className="p-4 pb-20">
      <ContractorPanelVisitsHeader
        title={t("navigation.contractorPanelSummary")}
        description={t("contractors.plannedHours.description")}
        className="mb-6"
      />

      {isBusy && <Spinner className="py-8" />}

      {!isBusy && shouldShowPlannedHoursButton && (
        <AsyncButton
          onClick={showHours}
          loading={isSubmitting}
          label={t("contractorPlannedHours.showHours")}
        />
      )}

      {!isBusy && shouldShowNoChangesMessage && (
        <p className="text-sm text-muted-foreground">
          {t("contractorPlannedHours.noChangesMessage")}
        </p>
      )}

      {acceptedPlannedHours && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t("contractorPlannedHours.fields.period")}</TableHead>
              <TableHead>
                {t("contractorPlannedHours.fields.planned_hours")}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell>{acceptedPlannedHours.period}</TableCell>
              <TableCell>{acceptedPlannedHours.planned_hours}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </div>
  );
};
